import { InjectionToken } from '@angular/core';
export const DebugFlagList = new InjectionToken('DebugFlagList');
export const DevelopmentModuleProdEnvironment = new InjectionToken('DevelopmentModuleProdEnvironment');
export const GlobalDebugFlags = [];
//# sourceMappingURL=debug-options.js.map